import { render } from "./ProviderCallback.vue?vue&type=template&id=60b49bf4&scoped=true"
import script from "./ProviderCallback.vue?vue&type=script&lang=js"
export * from "./ProviderCallback.vue?vue&type=script&lang=js"

import "./ProviderCallback.vue?vue&type=style&index=0&id=60b49bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b49bf4"]])

export default __exports__